<template>

    <Page>

        <h1 class="text-2xl font-semibold w-full 2xl:px-20">Reseller Opportunity</h1>
        <p class="mt-1 text-xl 2xl:px-20 w-full">
            We're now expanding further internationally and are actively looking for the right reseller partner to drive our success in-market in the UK.
        </p>
        <p class="mt-3 text-xl 2xl:px-20">
            We're not looking for just a distributor - we're looking for a true partner, someone already embedded in the UK automotive industry, who knows
            how dealerships operate, and more importantly, already has strong relationships with dealer groups.
        </p>

        <h1 class="text-2xl font-semibold mt-6 w-full 2xl:px-20">Ideally, you're someone who:</h1>
        <ul class="mt-1 list-disc text-white font-normal text-lg 2xl:px-20 w-full">
            <li class="pl-2 ml-5 mb-1">
                Has a strong network of franchise dealership contacts
            </li>
            <li class="pl-2 ml-5 mb-1">
                Is already supplying goods or services into the dealership ecosystem - whether that's tech, aftermarket, training, F&I, or consulting
            </li>
            <li class="pl-2 ml-5 mb-1">
                Understands the challenges dealers face around retention, customer experience, and margin pressure
            </li>
            <li class="pl-2 ml-5 mb-1">
                You don't need to build a platform - we've done that. You just need to be able to open doors, tell the story, and help us scale fast.
            </li>
        </ul>

    </Page>

</template>